import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import FirstForm from "./FirstForm";
import SecondForm from "./SecondForm";
import ThirdForm from "./ThirdForm";

// import the various invoice forms
import AutoInvoiceForm from "../../Invoice/AutoInvoiceForm";
import TravelInvoiceForm from "../../Invoice/TravelInvoiceForm";
import AccidentInvoiceForm from "../../Invoice/AccidentInvoiceForm";
import RCHInvoiceForm from "../../Invoice/RCHInvoiceForm";
import RCPInvoiceForm from "../../Invoice/RCPInvoiceForm";
import RCSInvoiceForm from "../../Invoice/RCSInvoiceForm";
import RCFInvoiceForm from "../../Invoice/RCFInvoiceForm";

import { Button, Stack, Spinner, Form, ProgressBar } from "react-bootstrap";
import {
  phoneRegex,
  emailRegex,
  objectHasEmptyItems,
} from "../../../utilities/validators";
import { postInvoice, uploadImage } from "../../../apis";

const MasterForm = ({ id, invoiceName, fullname }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [telephone, setTelephone] = useState("");
  const [message, setMessage] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);

  // states for the various invoices
  const [autoInvoice, setAutoInvoice] = useState({
    immatriculation: "",
    chassis_number: "",
    address: "",
    brand: "",
    type: "",
    model: "",
    energy: "",
    power: "",
    registration_doc: "",
  });
  const [travelInvoice, setTravelInvoice] = useState({
    destination_country: "",
    date_of_birth: "",
    duration: "",
    passport: "",
  });
  const [accidentInvoice, setAccidentInvoice] = useState({
    name: "",
    birthdate: "",
    birth_place: "",
    profession: "",
    guarantee: "",
    invalid: false,
  });
  const [rcfInvoice, setRCFInvoice] = useState({
    house_location: "",
    information_on_familly: "",
  });
  const [rcsInvoice, setRCSInvoice] = useState({
    information_on_school: "",
  });
  const [rcpInvoice, setRCPInvoice] = useState({
    information_on_profession: "",
  });
  const [rchInvoice, setRCHInvoice] = useState({
    activity: "",
    localisation: "",
  });



  const {t} = useTranslation()
  let invoiceForm = {};
  // we take the id of the invoice and determine the form to be passed
  // to the secondForm Component.
  if (id === 1) {
    invoiceForm = (
      <AutoInvoiceForm
        autoInvoice={autoInvoice}
        setAutoInvoice={setAutoInvoice}
      />
    );
  } else if (id === 2) {
    invoiceForm = (
      <TravelInvoiceForm
        travelInvoice={travelInvoice}
        setTravelInvoice={setTravelInvoice}
      />
    );
  } else if (id === 3) {
    invoiceForm = (
      <AccidentInvoiceForm
        accidentInvoice={accidentInvoice}
        setAccidentInvoice={setAccidentInvoice}
      />
    );
  } else if (id === 4) {
    invoiceForm = (
      <RCFInvoiceForm rcfInvoice={rcfInvoice} setRCFInvoice={setRCFInvoice} />
    );
  } else if (id === 5) {
    invoiceForm = (
      <RCSInvoiceForm rcsInvoice={rcsInvoice} setRCSInvoice={setRCSInvoice} />
    );
  } else if (id === 6) {
    invoiceForm = (
      <RCPInvoiceForm rcpInvoice={rcpInvoice} setRCPInvoice={setRCPInvoice} />
    );
  } else if (id === 7) {
    invoiceForm = (
      <RCHInvoiceForm rchInvoice={rchInvoice} setRCHInvoice={setRCHInvoice} />
    );
  } else {
    invoiceForm = (
      <AutoInvoiceForm
        autoInvoice={autoInvoice}
        setAutoInvoice={setAutoInvoice}
      />
    );
  }

  const next = () => {
    let step = currentStep >= 2 ? 3 : currentStep + 1;
    setCurrentStep(step);
  };
  const prev = () => {
    let step = currentStep;
    step = currentStep <= 1 ? 1 : currentStep - 1;
    setCurrentStep(step);
  };


  const submit = async() => {
    let submitObject = {
      name,
      email,
      telephone,
      insurrance: fullname,
      message,
    };
    setLoading(true);
    // we check if name, email or telephone fields are valid
    if (!name || !email || !telephone) {
      toast.error(
        "Assurer d'entrer votre nom, numero de telephone et e-mail !"
      );
      setLoading(false);
      setCurrentStep(1);
      return;
    }
    // Validate Phone number from stackoverflow
    else if (phoneRegex(submitObject.telephone)) {
      toast.error("Numero de telephone incorrect");
      setLoading(false);
      setCurrentStep(1);
      return;
    } else if (emailRegex(submitObject.email)) {
      toast.error("E-mail incorrect");
      setLoading(false);
      setCurrentStep(1);
      return;
    }

    function EmptyFieldError() {
      // I've found myself repeating this error checker over an over so,
      // I decided to encapsulate it into a function

      setCurrentStep(2);
      toast.error("Ces champs ne doivent pas etre vide !");
      setLoading(false);
    }
    // We put all the form data into
    // one object for submission and validation
    if (id === 1) {
      const isEmpty = objectHasEmptyItems(autoInvoice);
      if (isEmpty) {
        EmptyFieldError();
        return;
      } else {
        submitObject = { ...submitObject, auto_invoice: autoInvoice };
        setAutoInvoice({
          immatriculation: "",
          chassis_number: "",
          address: "",
          brand: "",
          type: "",
          model: "",
          energy: "",
          power: "",
          registration_doc: "",
        });
      }
      // We dont need to go through the other conditions
    } else if (id === 2) {

      const data = await uploadImage(travelInvoice.passport)

      // const isEmpty = objectHasEmptyItems(travelInvoice);
      const isEmpty = false
      if (isEmpty) {
        EmptyFieldError();
        return;
      } else {
        submitObject = { ...submitObject, travel_invoice: travelInvoice };
        if(data){
          // *** Exceptionally We will submit the form Headersthis is because
          // the submission process is async and together with the uploadImage
          // process but we need the image process to finish before we continue
          // to submit our form ***
          submitObject.travel_invoice.passport = data;
          postInvoice(submitObject).then((res) => {
            setName("");
            setEmail("");
            setTelephone("");
            setMessage("");
          });
          setLoading(false);
          return;
        }
        setTravelInvoice({
          destionation_country: "",
          date_of_birth: "",
          duration: "",
          passport: "",
        });      
      }
    } else if (id === 3) {
      const isEmpty = objectHasEmptyItems(accidentInvoice);
      if (isEmpty) {
        EmptyFieldError();
        return;
      } else {
        submitObject = { ...submitObject, accident_invoice: accidentInvoice };
        setAccidentInvoice({
          name: "",
          birthdate: "",
          birth_place: "",
          profession: "",
          guarantee: "",
          invalid: false,
        });
      }
    } else if (id === 4) {
      const isEmpty = objectHasEmptyItems(rcfInvoice);
      if (isEmpty) {
        EmptyFieldError();
        return;
      } else {
        submitObject = { ...submitObject, rcf_invoice: rcfInvoice };
        setRCFInvoice({
          house_location: "",
          information_on_familly: "",
        });
      }
    } else if (id === 5) {
      const isEmpty = objectHasEmptyItems(rcsInvoice);
      if (isEmpty) {
        EmptyFieldError();
        return;
      } else {
        submitObject = { ...submitObject, rcs_invoice: rcsInvoice };
        setRCSInvoice({
          information_on_school: "",
        });
      }
    } else if (id === 6) {
      const isEmpty = objectHasEmptyItems(rcpInvoice);
      if (isEmpty) {
        EmptyFieldError();
        return;
      } else {
        submitObject = { ...submitObject, rcp_invoice: rcpInvoice };
        setRCPInvoice({
          information_on_profession: "",
        });
      }
    } else if (id === 7) {
      const isEmpty = objectHasEmptyItems(rchInvoice);
      if (isEmpty) {
        EmptyFieldError();
        return;
      } else {
        submitObject = { ...submitObject, rch_invoice: rchInvoice };
        setRCHInvoice({
          activity: "",
          localisation: "",
        });
      }
    } else {
      toast.error("Ane erreur inattendue cest produite");
    }
    postInvoice(submitObject).then((res) => {
      setName("");
      setEmail("");
      setTelephone("");
      setMessage("");
    });
    setLoading(false);
  };

  return (
    <div className="invoice-page__modal">
      <h2>Formulaire de demande de devis pour {fullname}</h2>
      <p>{t("invoice_page_form_step")} {currentStep}</p>
      <ProgressBar now={currentStep * 33.33} label={`${currentStep * 33.33}%`} visuallyHidden />
      <Form className="invoice-page__modal_form" encType="multipart/form-data">
        <FirstForm
          currentStep={currentStep}
          name={name}
          setName={setName}
          telephone={telephone}
          setTelephone={setTelephone}
          email={email}
          setEmail={setEmail}
        />
        <SecondForm currentStep={currentStep}>{invoiceForm}</SecondForm>
        <ThirdForm
          currentStep={currentStep}
          message={message}
          setMessage={setMessage}
        />
      </Form>
      <Stack
        direction="horizontal"
        gap={2}
        className="invoice-page__modal_step-buttons"
      >
        {currentStep > 1 ? (
          <Button variant="lightgray" onClick={prev}>
            Previous
          </Button>
        ) : null}

        {currentStep < 3 ? (
          <Button className="ms-auto" variant="blue" onClick={next}>
            Next
          </Button>
        ) : null}
        {currentStep === 3 ? (
          <Button variant="green" className="ms-auto" onClick={submit}>
            {loading ? (
              <Spinner
                variant="standard"
                as="span"
                size="sm"
                role="status"
                animation="border"
                aria-hidden="true"
              />
            ) : (
              t("contact_page_form_submit_button")
            )}
          </Button>
        ) : null}
      </Stack>
      <ToastContainer containerId="an id" draggable={false} />
    </div>
  );
};

export default MasterForm;
